import React from 'react';
import { Box } from '@chakra-ui/react';
import {
  CampaignMappingView,
  CampaignMappingsDataContextProvider,
} from 'src/features/CampaignMapping';
import { DesktopOnlyGuard } from 'src/components/molecules/DesktopOnlyGuard';

export const CampaignsTab: React.FC = () => {
  return (
    <DesktopOnlyGuard>
      <CampaignMappingsDataContextProvider>
        <Box>
          <CampaignMappingView />
        </Box>
      </CampaignMappingsDataContextProvider>
    </DesktopOnlyGuard>
  );
};
